import * as React from 'react';

import { Button } from '../Button';
import { Form, FormSection, FormRow, FormField } from '../Form';
import { FormProgressIndicator } from '../FormProgressIndicator';
import { TextInput } from '../TextInput';
import { Text } from '../Text';
import { useFormState, areAllFieldsValid } from '../../hooks/form-state';

export const GroupStep = (props) => {
  const [formState, actions] = useFormState({
    companyName: {
      value: '',
      rule: /^.+$/,
    },
    employeeCount: {
      value: '',
      rule: /^[0-9]+$/,
    },
  });
  const isFormValid = areAllFieldsValid(formState);

  return (
    <Form
      onSubmit={() => {
        if (!isFormValid) {
          actions.showAllValidationErrors();

          return;
        }

        props.onSubmit(
          Object.keys(formState).reduce((accum, fieldId) => {
            accum[fieldId] = formState[fieldId].value;

            return accum;
          }, {}),
        );
      }}
    >
      <FormSection>
        <div className="justify-center mb-6">
          <FormProgressIndicator
            steps={['Basics', 'Company', 'Quote']}
            currentStepIndex={1}
          />
        </div>
        <Text.H4>Tell us a little more about your company.</Text.H4>
      </FormSection>
      <FormSection>
        <FormRow>
          <FormField
            labelText="Company Name"
            error={
              formState.companyName.shouldShowValidationError
                ? 'Please enter the company name.'
                : ''
            }
          >
            <TextInput
              value={formState.companyName.value}
              onChange={(value) => actions.setValue('companyName', value)}
            />
          </FormField>
          <FormField
            labelText="Number of Employees"
            error={
              formState.companyName.shouldShowValidationError
                ? 'Please enter the number of employees.'
                : ''
            }
          >
            <TextInput
              value={formState.employeeCount.value}
              onChange={(value) => actions.setValue('employeeCount', value)}
              inputMode="numeric"
            />
          </FormField>
        </FormRow>
        <FormRow>
          <div className="flex w-full justify-end mt-4">
            <Button
              variant="PRIMARY"
              size="LARGE"
              is="input"
              type="submit"
              value="Continue"
            />
          </div>
        </FormRow>
      </FormSection>
    </Form>
  );
};
